import React, { useEffect, useState } from 'react'
import { Row, Card, Form, Input, Radio, Space, Button, Col, Typography } from 'antd'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import { sendEmailForExpressPolicyChanges } from '../services'
import { ADD_DRIVER_JSON_MAP } from './AddDriverConstants'

import AddDriverStyle from '../../styles/AddDriver.module.css'

const { Text } = Typography
const { TextArea } = Input

const AddDriver = () => {
  useEffect(() => {
    window.location.href = "/404";
  }, []);

  return null;

  const [driver, setDriver] = useState({
    firstName: '',
    lastName: '',
    policyNumber: '',
    phoneNumber: '',
    streetAddress: '',
    city: '',
    zipCode: '',
    emailAddress: '',
    additionalDriver: {
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      maritalStatus: '',
      relationship: '',
      isInSameHousehold: '',
      streetAddress: '',
      apt: '',
      city: '',
      state: '',
      zipCode: '',
      isLicenseValid: '',
      licenseNumber: '',
      reason: '',
      effectDate: ''
    }
  })
  const [disableButton, setDisableButton] = useState(false)

  const buildTable = driverInfo => {
    var table = '<table border="1">'
    table += '<tr><td colspan="2"><b>Policyholder Information</b></td></tr>'
    for (const key in driverInfo) {
      if (driverInfo[key] instanceof Object) {
        table += '<tr><td colspan="2"><b>Additional Driver Information</b></td></tr>'
        for (const additionalKey in driverInfo[key]) {
          table += `<tr><td>${ADD_DRIVER_JSON_MAP[key][additionalKey]}</td><td>${driverInfo[key][additionalKey]}</td></tr>`
        }
      } else {
        table += `<tr><td>${ADD_DRIVER_JSON_MAP[key]}</td><td>${driverInfo[key]}</td></tr>`
      }
    }
    table += '</table>'
    return table
  }

  const validateBasicFormData = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      city,
      zipCode,
      emailAddress,
      additionalDriver: {
        firstName: additionalDriverFirstName,
        lastName: additionalDriverLastName,
        dateOfBirth,
        maritalStatus,
        relationship,
        isInSameHousehold,
        streetAddress: additionalDriverStreetAddress,
        city: additionalDriverCity,
        state,
        zipCode: additionalDriverZipCode,
        reason,
        isLicenseValid,
        licenseNumber,
        effectDate
      }
    } = driverInfo

    if (
      firstName &&
      lastName &&
      policyNumber &&
      phoneNumber &&
      streetAddress &&
      city &&
      zipCode &&
      emailAddress &&
      additionalDriverFirstName &&
      additionalDriverLastName &&
      dateOfBirth &&
      maritalStatus &&
      relationship &&
      isInSameHousehold &&
      isLicenseValid &&
      effectDate
    ) {
      if (isInSameHousehold === 'No') {
        if (additionalDriverStreetAddress && additionalDriverCity && state && additionalDriverZipCode) {
          if (isLicenseValid === 'Yes' && licenseNumber) {
            return { isValid: true }
          } else if (isLicenseValid === 'No' && reason) {
            return { isValid: true }
          } else {
            return { isValid: false }
          }
        } else {
          return { isValid: false }
        }
      } else {
        return { isValid: true }
      }
    } else {
      return { isValid: false }
    }
  }

  const validateDate = driverInfo => {
    const {
      additionalDriver: { dateOfBirth, effectDate }
    } = driverInfo

    if (new Date(dateOfBirth).toString() === 'Invalid Date' || new Date(effectDate).toString() === 'Invalid Date') {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const validateEmail = driverInfo => {
    const { emailAddress } = driverInfo
    const regEx = /\S+@\S+\.\S+/

    if (emailAddress.length > 0 && regEx.test(emailAddress)) {
      return { isValid: true }
    } else {
      return { isValid: false }
    }
  }

  const validateZipCode = driverInfo => {
    const { zipCode } = driverInfo

    if (zipCode.length < 5) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const formatPhoneNumber = phoneNumber => {
    const USNumber = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber ? `(${USNumber?.[1]}) ${USNumber?.[2]}-${USNumber?.[3]}` : ''
  }

  const validatePhoneNumber = driverInfo => {
    const { phoneNumber } = driverInfo
    const updatedNumber = phoneNumber.replace(/[^\w\s]/gi, '').replace(' ', '')
    if (formatPhoneNumber(updatedNumber).length < 10) {
      return { isValid: false }
    } else {
      return { isValid: true }
    }
  }

  const stripFinalJson = driverInfo => {
    const {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      city,
      zipCode,
      emailAddress,
      additionalDriver: {
        firstName: additionalDriverFirstName,
        lastName: additionalDriverLastName,
        dateOfBirth,
        maritalStatus,
        relationship,
        isInSameHousehold,
        apt,
        streetAddress: additionalDriverStreetAddress,
        city: additionalDriverCity,
        state,
        zipCode: additionalDriverZipCode,
        reason,
        isLicenseValid,
        licenseNumber,
        effectDate
      }
    } = driverInfo
    const obj = {
      firstName,
      lastName,
      policyNumber,
      phoneNumber,
      streetAddress,
      city,
      zipCode,
      emailAddress,
      additionalDriver: {
        firstName: additionalDriverFirstName,
        lastName: additionalDriverLastName,
        dateOfBirth,
        maritalStatus,
        relationship,
        isInSameHousehold,
        ...(isInSameHousehold === 'No' && {
          apt,
          streetAddress: additionalDriverStreetAddress,
          city: additionalDriverCity,
          state,
          zipCode: additionalDriverZipCode
        }),
        isLicenseValid,
        ...(isLicenseValid === 'No'
          ? {
            reason
          }
          : {
            licenseNumber
          }),
        effectDate
      }
    }
    return obj
  }

  const validateFields = driverInfo => {
    let validationResponse = true
    const initialResponse = validateBasicFormData(driverInfo)
    if (initialResponse.isValid) {
      const dateValidationResponse = validateDate(driverInfo)
      const emailValidationResponse = validateEmail(driverInfo)
      const zipCodeValidationResponse = validateZipCode(driverInfo)
      const phoneValidationResponse = validatePhoneNumber(driverInfo)
      if (
        dateValidationResponse.isValid &&
        emailValidationResponse.isValid &&
        zipCodeValidationResponse.isValid &&
        phoneValidationResponse.isValid
      ) {
        validationResponse = true
      } else {
        validationResponse = false
      }
    } else {
      validationResponse = false
    }
    return validationResponse
  }

  const handleSubmit = async () => {
    setDisableButton(true)
    const finalJson = stripFinalJson(driver)
    const htmlText = buildTable(finalJson)
    const mailObj = {
      subject: `[Add Driver] - ${driver.policyNumber}`,
      content: htmlText
    }
    localStorage.setItem('expressPolicyChangeType', 'Add Driver')

    await sendEmailForExpressPolicyChanges(mailObj)

    const newWindow = window.open('/g/express-policy-changes/result', '_self', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const updateUserTextFields = (text, field) => {
    const clonedUser = { ...driver }
    clonedUser[field] = text
    setDriver(clonedUser)
  }

  const buttonStatus = !validateFields(driver) || disableButton

  return (
    <div className="container">
      <GlobalHeader />
      <>
        <EmptyHeaderHero minHeight={true} title="Add Driver" />
        <div className={`${AddDriverStyle["add-driver"]}`}>
          <p className={`${AddDriverStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
          <Row>
            <Card className={`${AddDriverStyle["register-card"]}`}>
              <h5 className={`${AddDriverStyle["sub-label"]}`}>Policyholder Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                      placeholder="First Name*"
                      value={driver.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                      placeholder="Last Name*"
                      value={driver.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                      placeholder="Policy Number*"
                      value={driver.policyNumber}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${AddDriverStyle["input-text"]} ${AddDriverStyle["phone-number"]}`}
                      mask="(999) 999-9999"
                      onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                      placeholder="Phone Number*"
                      value={driver.phoneNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          streetAddress: event.target.value
                        })
                      }}
                      placeholder="Street Address*"
                      value={driver.streetAddress}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          city: event.target.value
                        })
                      }}
                      placeholder="City*"
                      value={driver.city}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      maxLength={5}
                      onChange={event => {
                        setDriver({
                          ...driver,
                          zipCode: event.target.value.replace(/\D/g, '')
                        })
                      }}
                      placeholder="Zip Code*"
                      value={driver.zipCode}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                      placeholder="Email Address*"
                      value={driver.emailAddress}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <h5 className={`${AddDriverStyle["sub-label"]}`}>Additional Driver Information</h5>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          firstName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      placeholder="First Name*"
                      value={driver.additionalDriver.firstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          lastName: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      placeholder="Last Name*"
                      value={driver.additionalDriver.lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${AddDriverStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          dateOfBirth: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      placeholder="DOB (mm/dd/yyyy)*"
                      value={driver.additionalDriver.dateOfBirth}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          maritalStatus: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      placeholder="Marital Status*"
                      value={driver.additionalDriver.maritalStatus}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddDriverStyle["input-text"]}`}
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          relationship: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      placeholder="Relationship to the Policyholder*"
                      value={driver.additionalDriver.relationship}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Text className={`${AddDriverStyle["form-label"]}`}>Resides in same household?*</Text>
                    <Radio.Group
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          isInSameHousehold: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      value={driver.additionalDriver.isInSameHousehold}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {driver.additionalDriver.isInSameHousehold === 'No' && (
                <>
                  <Text className={`${AddDriverStyle["form-effect-label"]}`}>Please provide the address where the driver resides.*</Text>
                  <Row>
                    <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                      <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${AddDriverStyle["input-text"]}`}
                          onChange={event => {
                            const additionalDriver = {
                              ...driver.additionalDriver,
                              streetAddress: event.target.value
                            }
                            setDriver({
                              ...driver,
                              additionalDriver
                            })
                          }}
                          placeholder="Street Address*"
                          value={driver.additionalDriver.streetAddress}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${AddDriverStyle["input-text"]}`}
                          onChange={event => {
                            const additionalDriver = {
                              ...driver.additionalDriver,
                              apt: event.target.value
                            }
                            setDriver({
                              ...driver,
                              additionalDriver
                            })
                          }}
                          placeholder="Apt Number"
                          value={driver.additionalDriver.apt}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                      <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${AddDriverStyle["input-text"]}`}
                          onChange={event => {
                            const additionalDriver = {
                              ...driver.additionalDriver,
                              city: event.target.value
                            }
                            setDriver({
                              ...driver,
                              additionalDriver
                            })
                          }}
                          placeholder="City*"
                          value={driver.additionalDriver.city}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${AddDriverStyle["input-text"]}`}
                          onChange={event => {
                            const additionalDriver = {
                              ...driver.additionalDriver,
                              state: event.target.value
                            }
                            setDriver({
                              ...driver,
                              additionalDriver
                            })
                          }}
                          placeholder="State*"
                          value={driver.additionalDriver.state}
                        />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                      <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                        <Input
                          autoComplete="off"
                          className={`${AddDriverStyle["input-text"]}`}
                          maxLength={5}
                          onChange={event => {
                            const additionalDriver = {
                              ...driver.additionalDriver,
                              zipCode: event.target.value.replace(/\D/g, '')
                            }
                            setDriver({
                              ...driver,
                              additionalDriver
                            })
                          }}
                          placeholder="Zip Code*"
                          value={driver.additionalDriver.zipCode}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <Text className={`${AddDriverStyle["form-label"]}`}>Does the driver have a valid license?*</Text>
                    <Radio.Group
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          isLicenseValid: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      value={driver.additionalDriver.isLicenseValid}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {driver.additionalDriver.isLicenseValid === 'Yes' && (
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddDriverStyle["input-text"]}`}
                        onChange={event => {
                          const additionalDriver = {
                            ...driver.additionalDriver,
                            licenseNumber: event.target.value
                          }
                          setDriver({
                            ...driver,
                            additionalDriver
                          })
                        }}
                        placeholder="Driver's License Number*"
                        value={driver.additionalDriver.licenseNumber}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {driver.additionalDriver.isLicenseValid === 'No' && (
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                      <TextArea
                        autoComplete="off"
                        className={`${AddDriverStyle["textarea-text"]}`}
                        onChange={event => {
                          const additionalDriver = {
                            ...driver.additionalDriver,
                            reason: event.target.value
                          }
                          setDriver({
                            ...driver,
                            additionalDriver
                          })
                        }}
                        placeholder="Please explain why*"
                        rows={4}
                        value={driver.additionalDriver.reason}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Text className={`${AddDriverStyle["form-effect-label"]}`}>What date would you like this change to go into effect?*</Text>
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddDriverStyle["margin-bottom-14"]}`}>
                    <InputMask
                      className={`${AddDriverStyle["dob"]}`}
                      mask="99/99/9999"
                      onChange={event => {
                        const additionalDriver = {
                          ...driver.additionalDriver,
                          effectDate: event.target.value
                        }
                        setDriver({
                          ...driver,
                          additionalDriver
                        })
                      }}
                      placeholder="mm/dd/yyyy*"
                      value={driver.additionalDriver.effectDate}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Row>
          <Row className={`${AddDriverStyle["submit-container"]}`}>
            <Form.Item className={`${AddDriverStyle["btn-control"]} ${AddDriverStyle["button-submit-form"]}`}>
              <Space>
                <Button className={`${AddDriverStyle["register"]} ${AddDriverStyle["register-form-button"]}`} disabled={buttonStatus} onClick={handleSubmit}>
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Row>
        </div>
      </>
      <GlobalFooter />
    </div>
  )
}

AddDriver.propTypes = {}

export default AddDriver
